import { render, staticRenderFns } from "./EditMsg.vue?vue&type=template&id=d42ce39a&scoped=true"
import script from "./EditMsg.vue?vue&type=script&lang=js"
export * from "./EditMsg.vue?vue&type=script&lang=js"
import style0 from "./EditMsg.vue?vue&type=style&index=0&id=d42ce39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42ce39a",
  null
  
)

export default component.exports